import * as React from 'react';

import { IDailyRentOfferForMobileSite } from '../../repositories/dailyrent/entities/daily_rent_offers_for_web/DailyRentOfferForMobileSite';

interface IOfferContextType extends React.PropsWithChildren {
  offer: IDailyRentOfferForMobileSite;
  offerPosition: number;
  offersLength: number;
}

const OfferContext = React.createContext<IOfferContextType | undefined>(undefined);

export const useOffer = () => {
  const context = React.useContext(OfferContext);
  if (!context) {
    throw new Error('useOffer must be used within an OfferProvider');
  }

  return context;
};

export const OfferProvider: React.FC<IOfferContextType> = ({ offer, offerPosition, offersLength, children }) => {
  const value = React.useMemo(() => ({ offer, offerPosition, offersLength }), [offer, offerPosition, offersLength]);

  return <OfferContext.Provider value={value}>{children}</OfferContext.Provider>;
};
